import type { MotionSkin, SkinAssetKey } from "./types";

export const SKIN_ASSET_KEYS: SkinAssetKey[] = ["background", "tipIdle", "tipUp", "tipDown", "accentUp", "accentDown"];

export type LoadedSkinAssets = Partial<Record<SkinAssetKey, HTMLImageElement>>;

const cache = new Map<string, Promise<HTMLImageElement | null>>();

function loadImage(src: string): Promise<HTMLImageElement | null> {
  if (typeof Image === "undefined") return Promise.resolve(null);
  const cached = cache.get(src);
  if (cached) return cached;
  const promise = new Promise<HTMLImageElement | null>((resolve) => {
    const image = new Image();
    image.decoding = "async";
    image.onload = () => resolve(image);
    image.onerror = () => resolve(null);
    image.src = src;
  });
  cache.set(src, promise);
  return promise;
}

export async function loadSkinAssets(skin: MotionSkin): Promise<LoadedSkinAssets> {
  const slots = skin.assetSlots ?? {};
  const entries = await Promise.all(
    SKIN_ASSET_KEYS.map(async (key) => {
      const src = slots[key];
      if (!src) return undefined;
      const image = await loadImage(src);
      return image ? ([key, image] as const) : undefined;
    })
  );
  const loaded: LoadedSkinAssets = {};
  for (const entry of entries) {
    if (entry) loaded[entry[0]] = entry[1];
  }
  return loaded;
}
